<div class="IconoWhatsApp" *ngIf="botonOcultar">
  <a href="https://wa.me/+528181564422?text=Hola, requiero más información sobre un inmueble..." target="_blank"
    class="whatsapp-container">
    <div class="whatsapp-text" >Contáctanos</div>
    <div class="whatsapp-icon">
      <img class="whatsapp-icon" src="Inmuebles/assets/iconos/whatsapp.svg" alt="Icono WhatsApp" />
    </div>
  </a>
</div>